export { ProfilePlaceholderPipe } from './profile-placeholder.pipe'